(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["availability-form"] && !Shopify.designMode) return;
  try {
    
  const params = new URLSearchParams(document.location.search);
  const productHandle = params.get('product');
  const variantId = params.get('variant');

  const productInput = document.querySelector('#availability__product');
  const sizeDropdown = document.querySelector('.size__selector');
  const sizeInput = sizeDropdown?.querySelector('#availability__size');
  const sizeButton = sizeDropdown?.querySelector('.dropdown__button-text');
  const sizeList = sizeDropdown?.querySelector('#size-selector__list');

  async function getProductDetails() {
    if (!productHandle) return;

    try {
      const res = await fetch(`${window.Shopify.routes.root}products/${productHandle}.js`);

      if (!res.ok) {
        throw new Error('Failed to fetch product data');
      }

      const product = await res.json();

      if (productInput) {
        productInput.value = product.title;
        productInput.classList.add('disabled');
      }

      if (sizeDropdown) {
        const selectedVariant = variantId
          ? product.variants.find((variant) => variant.id == variantId)
          : product.variants[0];

        const options = product.variants.map((variant) => {
          const li = document.createElement('li');
          li.classList.add('dropdown__item');
          li.tabIndex = -1;

          const a = document.createElement('a');
          a.href = '#';
          a.dataset.value = variant.title;
          a.textContent = variant.title;

          li.appendChild(a);

          return li;
        });

        const fragment = document.createDocumentFragment();
        for (const option of options) {
          fragment.appendChild(option);
        }

        sizeButton.textContent = selectedVariant.title;
        sizeInput.value = selectedVariant.title;
        sizeList.replaceChildren(fragment);
      }
    } catch (error) {
      throw new Error(error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    getProductDetails();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  const cartDrawer = document.getElementById('cart-drawer');

  document.addEventListener('DOMContentLoaded', () => {
    cartDrawer.open = true;
    // Hide the no-JS fallback once the drawer takes over.
    document.documentElement.classList.add('cart-page--js');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const menuToggle = document.querySelector('.header__nav-toggle');
  const menu = document.querySelector('.header__nav');

  function setMenuExpanded(open) {
    menu.classList.toggle('open', open);
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  menuToggle.addEventListener('click', () => {
    setMenuExpanded(!menu.classList.contains('open'));
  });

  document.addEventListener('click', (e) => {
    if (!menu.contains(e.target) && !menuToggle.contains(e.target)) {
      setMenuExpanded(false);
    }
  });

  // Escape closes the open menu and returns focus to the launcher.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('open')) {
      setMenuExpanded(false);
      menuToggle.focus();
    }
  });

  const dialog = document.querySelector('.localisation-modal');
  const languageToggle = document.querySelector('.header__language-toggle');

  if (languageToggle && dialog) {
    languageToggle.addEventListener('click', () => {
      if (dialog.open) {
        dialog.close();
      } else {
        dialog.showModal();
        languageToggle.setAttribute('aria-expanded', 'true');
      }
    });

    dialog.addEventListener('close', () => {
      languageToggle.setAttribute('aria-expanded', 'false');
      languageToggle.focus();
    });
  }

  const closeNav = document.querySelector('.header__close-nav');

  closeNav.addEventListener('click', () => {
    setMenuExpanded(false);
    menuToggle.focus();
  });

  const cartDrawer = document.getElementById('cart-drawer');
  const cartLink = document.querySelector('.header__cart-link');

  cartLink.addEventListener('click', () => {
    cartDrawer.open = true;
  });

  if (cartDrawer) {
    cartDrawer.addEventListener('open', () => {
      cartLink.setAttribute('aria-expanded', 'true');
    });
    cartDrawer.addEventListener('close', () => {
      cartLink.setAttribute('aria-expanded', 'false');
      cartLink.focus();
    });
  }

  } catch(e) { console.error(e); }
})();
})();
